import React, { useEffect, useRef } from 'react';
import arrow from '../images/redcoris-arrow.svg';

const AboutUs = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            },
            {
                threshold: 0.1,
            }
        );

        const elements = sectionRef.current.querySelectorAll('.hidden-element');
        elements.forEach((el) => observer.observe(el));

        return () => {
            if (sectionRef.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                const elements = sectionRef.current.querySelectorAll('.hidden-element');
                elements.forEach((el) => observer.unobserve(el));
            }
        };
    }, []);

    return (
        <section className="about-us-section" id="about" ref={sectionRef}>
            <div className="about-us-header hidden-element">
                <img src={arrow} alt="arrow" className="about-us-arrow" />
                <h2><span className="brand-red">RED</span>Coris — <span className="section-title-white">About us</span></h2>
            </div>

            <div className="bento-grid">
                <div className="bento-card card-large hidden-element" style={{ transitionDelay: '0ms' }}>
                    <div className="card-content">
                        <h3>Indie games</h3>
                        <p>
                            We are a small game development team from the Czech Republic. Developing games is fun and relaxing for us, and we want to create indie games that people can enjoy for hours.
                        </p>
                        <p>
                            We want to turn our ideas into reality, and we are determined to learn new things with every piece of the game so that our games are the best they can be.
                        </p>
                    </div>
                    <div className="card-background history-bg"></div>
                </div>

                <div className="bento-card card-medium hidden-element" style={{ transitionDelay: '200ms' }}>
                    <div className="card-content">
                        <h3>Powered by Unreal 5</h3>
                        <p>
                            We use Unreal Engine 5 because its technology allows us to create a unique gaming experience and enables fast and efficient teamwork.
                        </p>
                    </div>
                    <div className="card-background tech-bg"></div>
                </div>

                <div className="bento-card card-medium hidden-element" style={{ transitionDelay: '400ms' }}>
                    <div className="card-content">
                        <h3>Human Created</h3>
                        <div className="ai-badge">
                            <span className="no-ai-icon">🚫</span>
                            <span>No Generative AI</span>
                        </div>
                        <p>
                            Our internal policy prohibits the use of AI in game development; we want games to remain works of art. Everything you see in our games was created by real people.                        </p>
                    </div>
                    <div className="card-background ai-bg"></div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;